








































import { Mixins, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import OzIcon from 'library/v4/components/OzIcon.vue'

const snackbars = namespace('snackbars')

@Component({ components: { OzIcon } })
export default class SurfacePostReactionLikeNew extends Mixins() {
  @Prop({ required: true }) currentUserReacted!: boolean
  @Prop({ required: true }) reactionCount!: number
  @Prop({ required: true }) isPadletColorSchemeDark!: boolean
  @Prop({ required: true }) canReact!: boolean

  @snackbars.Action setSnackbar!: (payload: { message: string }) => void

  showReactionOffNotice(): void {
    const message = this.__('Reactions have been disabled by the admin.')
    this.setSnackbar({ message })
  }

  publishReaction(value): void {
    this.$emit('create', value)
  }

  removeReaction(): void {
    this.$emit('delete')
  }

  toggleLike(): void {
    if (this.currentUserReacted) {
      this.removeReaction()
    } else if (this.canReact) {
      this.publishReaction(1)
    } else {
      this.showReactionOffNotice()
    }
  }
}
